module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2chap"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("CHAPTER 5")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "chapsub"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Arctic Glide")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Wolverine was in a hurry to leave. He stood on the deck near the stern and surveyed the harbor and its surrounding terrain. A man unaccustomed to sentiment, he felt a fleeting emotion, a brief nostalgia for his homeland.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The terrain was rugged and severe, forged by unforgiving elements. He related to the transformative and relentless powers of Mother Nature. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Getting soft in your middle years?")]), _vm._v(" he asked himself. He shrugged off the thought and concentrated on the task at hand—preparing the ship to depart in the next few minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even though they were the only ship on the peninsula, he’d felt exposed for the last two days, a floating target. Of course he’d chosen this precise location because it afforded him the luxury of a clear field of view in all directions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What he’d told the inquisitive young fisherman was true—the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Arctic Glide")]), _vm._v(" had sustained a broken propeller, and he’d had to wait for one to be flown in from Anchorage. Once it arrived, his team had used the diving equipment on board and replaced the part earlier in the day.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("While waiting in plain sight for two days had not been part of the plan, the delay had provided a plausible cover story for his men to ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("ship their newly acquired equipment from a local carrier to Anchorage. The Pelican cases containing “research equipment” had arrived safely in Anchorage, where they’d been transferred to a commercial carrier to be flown across the United States and beyond. He’d checked the tracking number provided by the carrier, and the current status was “in transit.” The freight was currently over the Atlantic Ocean. Unless the plane crashed, its cargo would reach Europe shortly, and then it would be someone else’s problem. His mission was almost over. It was time to clean up.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Once they left the harbor, the plan was simple—take the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Arctic Glide")]), _vm._v(" to an isolated location near one of the other islands, send her to the bottom of the Bering Sea with her crew on board, and head to the offshore rendezvous point, where a stealth submarine awaited their return.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He untied the line from the port side of the boat and stepped onto the dock, dragging the heavy rope and coiling it on the ground for the next vessel. Finished, he started walking toward the other dock line when he heard someone shouting from behind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He turned and spotted a man in a dark blue coat and khaki cargo pants running toward him, waving his arms wildly. Approximately fifty yards behind the running figure was a blue-and-white Chevy pickup truck with Al’s Marina Repairs & Services painted on the side. Another figure waited in the driver’s seat. “Hey, mister! Hold on a second! I need to talk to you about the propeller! Hold on a sec!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The engine shop where we purchased the propeller? What now?")]), _vm._v(" The Wolverine’s senses immediately transitioned into a heightened state of alertness, and he stared hard at the approaching figure, mentally evaluating the man for any threat. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Obviously athletic, moves quickly and with ease . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The man reached him and bent over at the knees, breathing hard and looking up into the Wolverine’s face. The Wolverine noticed a scar down the left side of his face, partially concealed by a short beard. Intelligent green eyes met his gaze.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("“Thank God! ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("I thought you guys were going to take off, and then I’d have to deal with my asshole boss back there in the pickup truck,” he said sheepishly, glancing over his shoulder. “Sorry about the dramatic entry. Just didn’t want to miss you.” He paused and seemed to catch his breath again. He stuck out his hand, “I’m Tom Mackey from Al’s Marina where you guys bought the prop.” He motioned over his shoulder with one hand. “And I hate to tell you this, but there’s a problem with the credit card your man used.”")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The Wolverine shook the man’s hand. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Firm, confident . . .")]), _vm._v(" “Problem? What kind of problem?” he asked in perfect, unaccented English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We thought that the card went through initially when you guys picked it up and paid, but it turns out that due to the storm, all transactions weren’t actually getting processed. They got stuck in transit somewhere and never made it to the credit card company. I’m not surprised, really. Those companies know how to fleece a man to death. Anyhow, they called us less than an hour ago and told us they need to rerun the card. I hate to do this to you—and I completely apologize—but is there any way I can get that card again? I even brought the reader with me,” Tom said, smiling and holding up an iPhone with an attached credit card reader.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Wolverine’s mind raced through the probabilities. Tom seemed sincere. Other than his physical fitness and alert eyes, his story was plausible. He realized he had two options—kill Tom on the spot and try to stop the man in the pickup from fleeing; or play along, provide the credit card, and leave as soon as Tom and his friend left. He made his choice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tom, I’m Martin. Please come aboard. We’ll head up to the wheelhouse, and I’ll get you the card. And then when we’re done—and I don’t mean to be rude—we need to get back out. That storm put us behind schedule by a couple of days.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fair enough. I’ll get out of your hair as quickly as possible,” the man said as he stepped aboard the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Arctic Glide.")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("The two men crossed the flat deck, and Tom studied a submersible submarine suspended by a crane over the middle of the deck. It was painted a bright yellow in the tradition of deep-sea exploratory vehicles.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nice sub,” Tom said. “What are you guys using it for, if you don’t mind me asking?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Wolverine glanced back, saw genuine interest on Tom’s face, and said, “Not at all. And honestly, I couldn’t tell you all the details. The oil guys have been using it for underwater research. They’ve got so much gear on this boat it makes my head hurt thinking about it. I’m just hired help,” he added, smiling at Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hear you,” Tom said, and continued to look around the deck at the other pieces of machinery and equipment. “You sure do have a lot of gear,” he agreed, spotting three Quadcon industrial containers near the stern of the boat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The two men reached the entrance to the wheelhouse. The Wolverine lifted the handle up and opened the heavy door. He walked through the entrance and began to climb the metal stairs. Tom trailed close behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A loud "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("clang")]), _vm._v(" resounded through the tight, enclosed space. The Wolverine whipped his head around and looked down at the man on the steps below.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom still held the iPhone in front of him. It wasn’t that device that had made the sound. And then the Wolverine saw it. A bulge on the right hip, concealed by the dark blue Al’s Marina jacket. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Gun,")]), _vm._v(" his mind screamed at him. He examined the man’s face and saw something even more alarming in the green eyes that now stared back at him. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Predatory alertness, cold and calculating.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Without hesitation, he acted, and the desolate landscape of Dutch Harbor, Alaska, quickly turned into a battleground, an eventuality for which the islands had prepared during World War II but had never experienced—until today.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c152c9f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch05.vue
// module id = 87
// module chunks = 0